var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.912 18.5746C17.912 19.6271 17.0588 20.4803 16.0064 20.4803H4.47069C3.41824 20.4803 2.56506 19.6271 2.56506 18.5746V1.90562C2.56506 0.853176 3.41824 0 4.47069 0H12.6396C13.1726 0 13.6812 0.223182 14.042 0.615396L15.3601 2.04803L17.3526 4.03665C17.7107 4.39413 17.912 4.8794 17.912 5.38544V18.5746Z",
    fill: "#FCFCFC",
    stroke: "#107C42",
    strokeWidth: 0.952813,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.887695 5.16504H9.53223C10.0102 5.16504 10.3983 5.55289 10.3984 6.03125V14.6836C10.3984 15.162 10.0102 15.5498 9.53223 15.5498H0.887695C0.409939 15.5496 0.0225428 15.1618 0.0224609 14.6836V6.03125C0.022584 5.55303 0.409965 5.16528 0.887695 5.16504Z",
    fill: "#107C42",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87561 6.83105L8.2467 14.2314H6.80334L2.40295 6.83105H3.87561Z",
    fill: "white",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2467 6.83105L3.84631 14.2314H2.40295L6.77405 6.83105H8.2467Z",
    fill: "white",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4539 7.83203V8.90137H10.988V7.83203H13.4539Z",
    fill: "#21A365",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5563 7.83203V8.90137H14.0905V7.83203H16.5563Z",
    fill: "#33C481",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4539 9.51465V10.584H10.988V9.51465H13.4539Z",
    fill: "#107C42",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5563 9.51465V10.584H14.0905V9.51465H16.5563Z",
    fill: "#21A365",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4539 11.1982V12.2676H10.988V11.1982H13.4539Z",
    fill: "#195D38",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5563 11.1982V12.2676H14.0905V11.1982H16.5563Z",
    fill: "#104B2B",
    stroke: "#107C42",
    strokeWidth: 0.04518
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.9ad698b4a2a011562f37e5ae1a2e035a.svg";
export { ForwardRef as ReactComponent };